module.exports = __webpack_public_path__ + "static/media/hab-group.2b2d9619.svg";